import React, { useEffect, useState } from "react";

import useAppInsightsHandler from "hooks/useAppInsightsHandler.js";

import { getAlarmsHistory } from "api/alarmsHistory.js";

import getLogger from "utils/logger.util";
import { getRowFormattedData } from "utils/utils";
import { AlarmPageStrings, ALARMS_TABLE_STRINGS } from "constants/constantStrings";

import AgTable from "components/AgTable";
import Filter from "components/Filter";
import PageLoading from "components/PageLoading/";
import TableDialog from "components/TableDialog";

import { getAlarmHistoryTableColDefs } from "./AlarmHistory.table.config";

const AlarmHistory = () => {
  const Logger = getLogger('AlarmHistory');
  const [isLoaded, setIsLoaded] = useState(false);
  const [alarmsHistory, setAlarmsHistory] = useState([]);
  const [filterValue, setFilterValue] = useState("");
  const [showTableFilterIcon, setShowTableFilterIcon] = useState(false);
  const columdefs = getAlarmHistoryTableColDefs(showTableFilterIcon);
  const [popupData, setPopupData] = useState();
  const objAppInsights = useAppInsightsHandler();

  useEffect(() => {
    let isMounted = true;
    const fetchData = async () => {
      try {
        const response = await getAlarmsHistory();
        if (isMounted) {
          if (response.status >= 200 && response.status < 300) {
            setAlarmsHistory(response.data.Alarms);
            setIsLoaded(true);
          }
        }
      } catch (err) {
        Logger.error('fetchData - Error: ', err);
      }
    };
    fetchData();
    return () => {
      isMounted = false;
    };
  }, []);

  const closePopup = () => setPopupData(null);
  const onRowClicked = ({ data }) => {
    objAppInsights.trackEvent("alarmHistoryRowClick");
    const rowData = getRowFormattedData(columdefs, data);
    const title = data.AlarmId;
    const subTitle = ALARMS_TABLE_STRINGS.viewAlarm;
    setPopupData({ title, subTitle, rowData });
  };

  return (
    <>
      {!isLoaded ? (
        <PageLoading customHeight={"calc(100vh - 150px)"} />
      ) : (
        <>
          <div className="flex-between marginBtm20">
            <span className="alarm-description descriptionText">{AlarmPageStrings.seeAllPastAlarms}</span>
            <div className="jc-end">
              <Filter
                data={alarmsHistory}
                setFilterValue={setFilterValue}
                placeholder={AlarmPageStrings.searchHere}
                setShowTableFilterIcon={setShowTableFilterIcon}
                showTableFilterIcon={showTableFilterIcon}
                customClass="marginBtm10"
              />
            </div>
          </div>
          <AgTable
            rowData={alarmsHistory}
            onRowClicked={onRowClicked}
            quickFilterText={filterValue}
            setShowTableFilterIcon={setShowTableFilterIcon}
            showTableFilterIcon={showTableFilterIcon}
            columnDefs={columdefs}
            customHeight="calc(100vh - 215px)"
          />
          {popupData && <TableDialog popupData={popupData} closePopup={closePopup} />}
        </>
      )}
    </>
  );
};

export default AlarmHistory;
